// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0ea0300d","455":"7a037583","977":"07ee841d"}[chunkId] + ".chunk.js";
};